import {
    ScrollView,
    View,
    ActivityIndicator
} from "../../../custom-packages/react-native-components-in-react/react-native-components-in-react";

import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {Link, useNavigate, useParams} from "react-router-dom";
import PollQuestion from "../../../models/poll/PollQuestion";
import AppConfig from "../../../AppConfig";
import {Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from "recharts";
import Poll from "../../../models/poll/Poll";
import {ReturnButton} from "../../../custom-packages/react-button-package/ButtonPackage";

const TPollResultScreen = {
    // English
    "enUS": {
        // FOR POLLING
        'RESULTS': 'Results',
        'TERRIBLE': "Terrible",
        'BAD': "Bad",
        'NEUTRAL': "Neutral",
        'GOOD': "Good",
        'EXCELLENT': "Excellent",
        'AVERAGE': "Average",
        'POLL_DETAILS': "See this poll",
        '30_DAYS': "Last 30 days",
        '12_MONTHS': "Last 12 months",
        'NO_RESULTS': "This poll has not responses yet",
        'RETURN': "Return",
    },
    // Spanish
    "esMX": {
        // FOR POLLING
        'RESULTS': 'Resultados',
        'TERRIBLE': "Terrible",
        'BAD': "Malo",
        'NEUTRAL': "Neutral",
        'GOOD': "Bueno",
        'EXCELLENT': "Excelente",
        'AVERAGE': "Promedio",
        'POLL_DETAILS': "Ver esta encuesta",
        '30_DAYS': "Últimos 30 días",
        '12_MONTHS': "Últimos 12 meses",
        'NO_RESULTS': "No han respondido esta encuesta",
        'RETURN': "Regresar",
    }
}

const PollResultScreen = () => {
    // @ts-ignore
    const auth = useSelector(state => state.Auth)
    const navigate = useNavigate()
    const params = useParams()
    const pollID = params.id;

    const [loading, setLoading] = useState(true);

    const [timeframe, setTimeframe] = useState<string>("30 DAYS")

    const [poll, setPoll] = useState<Poll>(new Poll())
    const [questions, setQuestions] = useState<Array<PollQuestion>>([new PollQuestion()])

    const answerScoreAverage = (answers) => {
        if(answers.length == 0)
            return

        let average = 0;

        for(let i = 0; i < answers.length; i++){
            average += answers[i].pra_score;
        }

        average = average / answers.length;

        return average.toFixed(2);
    }

    const convertToPieChartData = (answers) => {
        const totalExcellent = answers.filter(item => item.pra_score === 5).length;
        const totalGood = answers.filter(item => item.pra_score === 4).length;
        const totalNeutral = answers.filter(item => item.pra_score === 3).length;
        const totalBad = answers.filter(item => item.pra_score === 2).length;
        const totalTerrible = answers.filter(item => item.pra_score === 1).length;

        const data = new Array<any>();

        if(totalExcellent > 0){
            data.push({
                id: 5,
                name: TPollResultScreen[AppConfig.lang].EXCELLENT,
                value: totalExcellent
            })
        }

        if(totalGood > 0){
            data.push({
                id: 4,
                name: TPollResultScreen[AppConfig.lang].GOOD,
                value: totalGood
            })
        }

        if(totalNeutral > 0){
            data.push({
                id: 3,
                name: TPollResultScreen[AppConfig.lang].NEUTRAL,
                value: totalNeutral
            })
        }

        if(totalBad > 0){
            data.push({
                id: 2,
                name: TPollResultScreen[AppConfig.lang].BAD,
                value: totalBad
            })
        }

        if(totalTerrible > 0){
            data.push({
                id: 1,
                name: TPollResultScreen[AppConfig.lang].TERRIBLE,
                value: totalTerrible
            })
        }

        return data
    }

    const fetchData = async () => {
        setLoading(true)
        const response = await fetch('/Poll/Results/' + pollID + '?timeframe=' + timeframe, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.token
            },
        });

        const responseData = await response.json();

        const questions = [...responseData.poll.questions]

        for(let i = 0; i < questions.length; i++){
            questions[i].chartData = convertToPieChartData(questions[i].answers)
        }

        setPoll(responseData.poll)
        setQuestions(questions)

        setLoading(false)
    }

    useEffect(() => {
        fetchData()
    }, [timeframe]);

    if (loading)
        return <ActivityIndicator style={{marginTop: 50}}/>

    return <ScrollView>
        <ReturnButton
            text={TPollResultScreen[AppConfig.lang].RETURN}
            onPress={() => {
                navigate(-1)
            }}
        />
        <h1>
            {poll.pol_name}
        </h1>
        <div>
            {poll.pol_description}
        </div>
        <h2
            style={{
                marginTop: 15
            }}
        >
            {TPollResultScreen[AppConfig.lang].RESULTS}
        </h2>
        <select
            className={'form-control'}
            style={{
                marginBottom: 15,
                textAlign: 'center'
            }}
            onChange={(e) => {
                setTimeframe(e.target.value)
            }}
            value={timeframe}
        >
            <option value={'30 DAYS'} selected={timeframe === "30 DAYS"}>{TPollResultScreen[AppConfig.lang]['30_DAYS']}</option>
            <option value={'12 MONTHS'} selected={timeframe === "12 MONTHS"}>{TPollResultScreen[AppConfig.lang]['12_MONTHS']}</option>
        </select>
        <div
            className={'row'}
        >
            {
                questions.length > 0 && questions[0].answers.length > 0 ?
                    questions.map(item => {

                        return <View
                            key={item.pqu_id}
                            style={{
                                marginBottom: 30
                            }}
                            className={'col-12 col-lg-6'}
                        >
                            <View
                                className={'card'}
                            >
                                <View
                                    className={'card-body'}
                                >
                                    <h2
                                        style={{
                                            marginBottom: 15
                                        }}
                                    >
                                        {item.pqu_question}
                                    </h2>
                                    {
                                        item.pqu_type == "OPEN" ?
                                            null
                                            :
                                            <View
                                                className={'alert alert-info'}
                                            >
                                                <div>
                                                    {TPollResultScreen[AppConfig.lang].AVERAGE}: <strong>{answerScoreAverage(item.answers)} /
                                                    5</strong>
                                                </div>
                                            </View>
                                    }
                                    <View>
                                        {
                                            item.pqu_type == "OPEN" ?
                                                <ol>
                                                    {
                                                        item.answers.map(answer => {
                                                            if (!answer.pra_answer)
                                                                return

                                                            return <li
                                                                style={{
                                                                    marginBottom: 25
                                                                }}
                                                            >
                                                                <View>
                                                                    {
                                                                        answer.pra_answer
                                                                    }
                                                                </View>
                                                                <View
                                                                    style={{
                                                                        color: 'gray'
                                                                    }}
                                                                >
                                                                    {
                                                                        answer.pra_date?.split('T')[0]
                                                                    }
                                                                </View>
                                                                <Link
                                                                    style={{
                                                                        marginTop: 10
                                                                    }}
                                                                    to={'/admin/survey/response/' + answer.pra_poll_response_id}
                                                                >
                                                                    {TPollResultScreen[AppConfig.lang].POLL_DETAILS}
                                                                </Link>
                                                            </li>
                                                        })
                                                    }
                                                </ol>
                                                :
                                                <View>
                                                    <ResponsiveContainer
                                                        width={'100%'}
                                                        height={400}
                                                    >
                                                        <PieChart>
                                                            <Pie
                                                                data={item.chartData}
                                                                labelLine={false}
                                                                label={({
                                                                            name,
                                                                            percent
                                                                        }) => `${(percent * 100).toFixed(0)}%`}
                                                                fill="#8884d8"
                                                                dataKey="value"
                                                            >
                                                                {//@ts-ignore
                                                                    item.chartData.map((entry, index) => {
                                                                        let color = '';

                                                                        if (entry.id == 5)
                                                                            color = '#57a773';

                                                                        if (entry.id == 4)
                                                                            color = '#88b04b';

                                                                        if (entry.id == 3)
                                                                            color = '#d9ad26';

                                                                        if (entry.id == 2)
                                                                            color = '#e78c39';

                                                                        if (entry.id == 1)
                                                                            color = '#e94d4d';


                                                                        return <Cell key={`cell-${index}`} fill={color}/>
                                                                    })}
                                                            </Pie>
                                                            <Tooltip/>
                                                            <Legend/>
                                                        </PieChart>
                                                    </ResponsiveContainer>
                                                </View>
                                        }
                                    </View>
                                </View>
                            </View>
                        </View>
                    })
                    :
                    <div
                        className={'col-12'}
                    >
                        <div
                            style={{
                                textAlign: 'center',
                            }}
                            className={'alert alert-info'}
                        >
                            {TPollResultScreen[AppConfig.lang].NO_RESULTS}
                        </div>
                    </div>
            }
        </div>
    </ScrollView>
}

export default PollResultScreen;